import React from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import Alert from 'components/V1/Alert/Alert';
import { Box } from '@applatform/design-system';
import Input from 'components/V1/Input/Input';
import Button from 'components/V1/Button/Button';
import FormLabel from 'components/V1/FormLabel/FormLabel';
import FormErrorMessage from 'components/V1/FormErrorMessage/FormErrorMessage';
import Link from 'components/V1/Link/Link';
import Heading from 'components/V1/Heading/Heading';
import EnvironmentToggle from './EnvironmentToggle/EnvironmentToggle';
import useLoginForm from './useLoginForm';

function Login() {
  const {
    initialValues,
    validationSchema,
    handleSubmit,
    error,
    isSubmitting,
    Track,
  } = useLoginForm();

  return (
    <Track>
      <Heading size="2xl" as="h2" css={{ mb: '$8' }}>
        Login
      </Heading>
      <EnvironmentToggle />
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ errors, touched }) => (
          <Box as={Form} css={{ textAlign: 'left' }}>
            {error && (
              <Alert status="error" css={{ mb: '$6', '@md': { mt: '-$2' } }}>
                {error}
              </Alert>
            )}

            <Box css={{ mb: '$6' }}>
              <FormLabel htmlFor="email">Email</FormLabel>
              <Field
                as={Input}
                id="email"
                name="email"
                type="email"
                placeholder="name@platform.com"
                aria-invalid={Boolean(errors.email && touched.email)}
              />
              <ErrorMessage component={FormErrorMessage} name="email" />
            </Box>
            <Box css={{ mb: '$10' }}>
              <FormLabel htmlFor="password">Password</FormLabel>
              <Field
                as={Input}
                id="password"
                name="password"
                type="password"
                aria-invalid={Boolean(errors.password && touched.password)}
              />
              <ErrorMessage component={FormErrorMessage} name="password" />
            </Box>
            <Button
              type="submit"
              variant="primary"
              size="lg"
              isLoading={isSubmitting}
              fullWidth
            >
              Log in
            </Button>
          </Box>
        )}
      </Formik>
      <Box css={{ mt: '$8', textAlign: 'center' }}>
        <Link to="/reset-password">Reset password</Link>
      </Box>
    </Track>
  );
}

export default Login;
